import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomHamburguerMenuComponent} from './custom-hamburguer-menu.component';
import {CmsConfig, ConfigModule} from '@spartacus/core';
import {CustomIconsModule} from '../../../../../custom/icons/custom-icons.module';


@NgModule({
  declarations: [CustomHamburguerMenuComponent],
  imports: [
    CommonModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        HamburgerMenuComponent: {
          component: CustomHamburguerMenuComponent,
        },
      },
    } as CmsConfig)
  ]
})
export class CustomHamburguerMenuModule { }
